import { ref } from "vue";

/**
 * 画面ロジックを扱う composable。
 */
export const useDeliveryRequestUiState = () => {
  const errdialog = ref(false);
  const errMessage = ref("");
  const editPage = ref(false);
  const confirmPage = ref(false);
  const panel = ref<number[]>([0]);
  const processFlag = ref(0);
  const confirmDeleteDialog = ref(false);
  const addressDialog = ref(false);
  const areaDialog = ref(false);
  const overlay = ref(false);
  const confirmTagPrintDialog = ref(false);
  const confirmSlipPrintDialog = ref(false);
  const downloadingDialog = ref(false);
  const displayListSettingDialog = ref(false);
  const displayListSearchDialog = ref(false);
  const onClickListSearch = (): void => {
    displayListSearchDialog.value = true;
  };
  const openListPage = (): void => {
    editPage.value = false;
    confirmPage.value = false;
  };
  const openConfirmDeletePage = (): void => {
    processFlag.value = 2;
    editPage.value = false;
    confirmPage.value = true;
  };
  const openViewPage = (): void => {
    processFlag.value = 3;
    editPage.value = false;
    confirmPage.value = true;
  };

  return {
    errdialog,
    errMessage,
    editPage,
    confirmPage,
    panel,
    processFlag,
    confirmDeleteDialog,
    addressDialog,
    areaDialog,
    overlay,
    confirmTagPrintDialog,
    confirmSlipPrintDialog,
    downloadingDialog,
    displayListSettingDialog,
    displayListSearchDialog,
    onClickListSearch,
    openListPage,
    openConfirmDeletePage,
    openViewPage,
  };
};
